import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

const reports = require('../../mocks/voip-reports.json');
@Component({
  selector: 'nrwl-voip-reports',
  templateUrl: './voip.reports.component.html',
  styleUrls: ['./voip.reports.component.scss']
})
export class VoipReportsComponent implements OnInit, OnChanges {
  @Input() expertView = false;
  @Input() reportName;
  // eslint-disable-next-line
  selectedReport: any;

  ngOnInit(): void {
    if (this.reportName) {
      this.selectedReport = reports[this.reportName];
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.reportName && changes.reportName.currentValue) {
      this.selectedReport = reports[changes.reportName.currentValue];
    }
  }
}
